import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface Style {
  error?: boolean
}
export default styled.div`
  z-index: 205;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;

  position: fixed;
  top: 0;
  left: 0;

  background: ${(props: Style) => {
    if (props.error) return '#dc5d6c'
    return '#E07A58'
  }};

  .feedback-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    gap: 30px;

    span {
      color: ${Theme.pallete.PRIMARY};
      text-align: center;
      font-family: ${Theme.fontFamily.PRIMARY};
      font-size: 30px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  .loading-img {
    width: 100px;
    height: 100px;

    padding: 31.67px 25px;

    border-radius: 50px;
    border: 5px solid black;
  }
`
